<script lang="ts">
  import { ResponsiveVars, TwistBox } from '@twist/core';
  import ArrowDown from '$components/Icons/ArrowDown.svelte';
  import BlockButton from '$components/Button/BlockButton.svelte';
  import Container from '$components/News/Container.svelte';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { jobsStore } from '$lib/stores/Careers/jobsStore';
  import { cx } from '@emotion/css';
  import {
    useEncodeDataAttribute,
    type ContentSourceMap,
    type StudioPathLike
  } from '@sanity/svelte-loader';
  import { sanityStudioURL } from '$lib/client';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';
  import HeadingSizeDecorator from '$components/Common/HeadingSizeDecorator.svelte';

  function handleScrollToJobs() {
    document.getElementById('jobs-list-filters')?.scrollIntoView({ behavior: 'smooth' });
  }

  export let title = 'Work at Block';
  export let sourceMap: ContentSourceMap | undefined = undefined;
  export let path: StudioPathLike = [];

  $: encodeDataAttribute = useEncodeDataAttribute(title, sourceMap, sanityStudioURL);
  $: brandReskinEnabled = flagValue(FEATURE_FLAGS.BRAND_RESKIN);

  const responsiveVars = new ResponsiveVars()
    .addFluid('h1-font-size', toFluidVarInput(38, 100))
    .addFluid('icon-size', toFluidVarInput(24, 24))
    .toCSS();
</script>

<div class={cx('hero', responsiveVars)}>
  <TwistBox paddingTop={toFluidVarInput(200, 288)} paddingBottom={toFluidVarInput(64, 96)}>
    <Container>
      <TwistBox marginBottom={toFluidVarInput(30, 30)}>
        {#if brandReskinEnabled}
          <h1 data-sanity={encodeDataAttribute([...path, 'title'])}>
            <HeadingSizeDecorator size="display">
              {title}
            </HeadingSizeDecorator>
          </h1>
        {:else}
          <h1 data-sanity={encodeDataAttribute([...path, 'title'])}>{title}</h1>
        {/if}
      </TwistBox>

      <BlockButton
        fontSize={brandReskinEnabled ? toFluidVarInput(12, 12) : toFluidVarInput(18, 18)}
        px={toFluidVarInput(15, 21)}
        py={toFluidVarInput(9, 12)}
        height={toFluidVarInput(36, 42)}
        on:click={handleScrollToJobs}
      >
        <TwistBox marginRight={toFluidVarInput(6, 6)}>
          {$jobsStore.aggregates.total} open job{$jobsStore.aggregates.total === 1 ? '' : 's'}
        </TwistBox>

        <!-- TODO: Replace with TwistBox after block-web is updated to use new tokens -->
        <div class="icon-container">
          <ArrowDown />
        </div>
      </BlockButton>
    </Container>
  </TwistBox>
</div>

<style lang="scss">
  @import 'src/scss/media';

  .hero {
    --theme-button-primary-button-default-foreground-color: var(--twist-color-gray-100);
    --theme-button-primary-button-active-foreground-color: var(--twist-color-gray-0);
    --theme-button-primary-button-hover-focus-foreground-color: var(--twist-color-gray-0);
    --theme-button-primary-button-default-background-color: #e2e2e2;
    --theme-button-primary-button-active-background-color: #666666;
    --theme-button-primary-button-hover-focus-background-color: #666666;
    background-color: var(--twist-color-gray-100);
    text-align: center;
    padding-bottom: 100px;

    h1 {
      color: var(--twist-color-gray-0);
      font-family: var(--font-family-primary);
      font-size: var(--h1-font-size);
      font-weight: 700;
      line-height: 110%;
    }
  }

  .icon-container {
    width: var(--icon-size);
    height: var(--icon-size);
  }
</style>
